import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Eur = function Eur(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EUR_svg__EUR_svg__clip0_9086_39)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.946 9.32V8.5H6.813a5.718 5.718 0 01-.022-.443c0-.153.005-.3.021-.443h3.134v-.82H7.004C7.409 5.744 8.349 5.18 9.54 5.18c.389 0 .832.044 1.089.099V4.092c-.246-.076-.728-.126-1.11-.126-1.997 0-3.533.985-4.004 2.828H4.461v.82h.924a5.778 5.778 0 000 .886h-.924v.82h1.06c.471 1.838 2.002 2.822 3.999 2.822.415 0 .858-.038 1.12-.104v-1.197c-.224.06-.688.093-1.115.093-1.187 0-2.116-.564-2.516-1.614h2.937z",
    fill: "#505F79"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EUR_svg__EUR_svg__clip0_9086_39"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
export default Eur;